module.exports = __webpack_public_path__ + "img/64.8aa789e7.jpg";